import { t } from '../../i18n-t';
import type { FormConfig } from '../types';

export const getControlFormConfig = () => {
  return {
    Type: {
      fieldId: 'Type',
      formLabel: t(`controls.fields.Type`),
      columnHeader: t(`controls.columns.type`),
      displayType: {
        displayType: 'commonLookup',
        i18nKey: 'controls.type',
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    Title: {
      fieldId: 'Title',
      formLabel: t(`controls.fields.Title`),
      columnHeader: t(`controls.columns.title`),
      allowAsConditionSource: true,
    },
    Description: {
      fieldId: 'Description',
      formLabel: t(`controls.fields.Description`),
      columnHeader: t(`controls.columns.description`),
      allowTargetConditions: true,
      displayType: { displayType: 'textarea' },
    },
    Owners: {
      fieldId: 'Owners',
      formLabel: t(`fields.Owner`),
      columnHeader: t(`columns.owners`),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
    },
    Contributors: {
      fieldId: 'Contributors',
      formLabel: t(`fields.Contributor`),
      columnHeader: t(`columns.contributors`),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    Viewers: {
      fieldId: 'Viewers',
      formLabel: t(`fields.Viewer`),
      columnHeader: t(`columns.viewers`),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    tags: {
      fieldId: 'tags',
      formLabel: t(`fields.Tags`),
      columnHeader: t(`columns.tags`),
      displayType: {
        displayType: 'tags',
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    departments: {
      fieldId: 'departments',
      formLabel: t(`fields.Departments`),
      columnHeader: t(`columns.departments`),
      displayType: {
        displayType: 'departments',
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
  } as const satisfies FormConfig;
};
